import baseApi from './baseApi'

const permissionsApi = baseApi.injectEndpoints({
    endpoints: (build) => ({
        getPermissionsCatalog: build.query({
            query: () => ({
                url: 'permissions',
                method: 'GET',
            }),
            transformResponse: (res) => res,
            providesTags: () => [{type: 'PermissionsCatalog', id: 'LIST'}],
        }),
        getUserAccountPermissions: build.query({
            query: ({userId, accountId}) => ({
                url: `permissions/users/${userId}/accounts/${accountId}`,
                method: 'GET',
            }),
            transformResponse: (res) => res,
            providesTags: (result, error, arg) => [
                {type: 'UserPermissions', id: `${arg?.userId}-${arg?.accountId}`},
            ],
        }),
        setUserCustomPermission: build.mutation({
            query: ({userId, accountId, resource, permissions}) => ({
                url: `permissions/users/${userId}/accounts/${accountId}`,
                method: 'POST',
                body: {resource, permissions},
            }),
            transformResponse: (res) => res,
            invalidatesTags: (result, error, arg) => [
                {type: 'UserPermissions', id: `${arg?.userId}-${arg?.accountId}`},
            ],
        }),
    }),
})

export const {
    useGetPermissionsCatalogQuery,
    useGetUserAccountPermissionsQuery,
    useSetUserCustomPermissionMutation,
} = permissionsApi

export default permissionsApi
